/// <amd-module name="Artifacts/Root/redux/Contracts" />

import { ComponentState } from "Artifacts/Root/Constants";
import { IFeed } from "Artifacts/Root/types";

export interface ICurrentModal<T> {
  modalId: string;
  props: T;
}

export interface IRootState {
  feed?: IFeed;
  modal?: ICurrentModal<any>;
  promoteCommandState: ComponentState;
  permDeleteCommandState: ComponentState;
  softDeleteCommandState: ComponentState;
  unlistRelistCommandState: ComponentState;
  restoreCommandState: ComponentState;
  deprecateCommandState: ComponentState;
}

export interface IRootModuleState {
  rootState: IRootState;
}
